import Vector from '@/media/icons/lk_client.svg?react';
import Parseint from '@/media/icons/percent.svg?react';

import { type CreateLeasingProps } from './form-types';

export const VALIDATION_TRIGGER_ARRAY: Array<Array<keyof CreateLeasingProps>> =
  [
    [
      // First step fields
      'leasingAmount',
      'initialPayment',
      'leasingPeriod',
      'vehicles',
      'iin',
      'companyName',
      'bankDetails',
      'oked',
      'jobType',
      'country',
      'legalAddress',
      'typeOfProperty',
      'registrationPlace',
      'registrationNumber',
      'registrationDate',
      'startWork',
      'license',
      'licenseDescription',
      'licenseNumber'
    ],
    [
      // Second step fields
      'fullName',
      'phone',
      'email',
      'managerName',
      'managerDocument',
      'managerDocumentNumber',
      'managerDocumentIssueDate',
      'managerDocumentEndDate',
      'balanceSheet',
      'statement',
      'financeReport',
      'fno',
      'creditHistory',
      'ocStatement',
      'additionalDocuments'
    ]
  ];

export const stepCountItemsData: {
  title: string;
  titleMobile: string;
  totalFields: number;
  validFields: number;
  icon: React.ReactNode;
}[] = [
  {
    title: 'Информация о клиенте',
    titleMobile: 'Клиент',
    totalFields: VALIDATION_TRIGGER_ARRAY[0].length,
    validFields: 0,
    icon: <Vector />
  },
  {
    title: 'Доп. информация',
    titleMobile: 'Доп.инфо',
    totalFields: VALIDATION_TRIGGER_ARRAY[1].length,
    validFields: 0,
    icon: <Parseint />
  }
];

export const defaultInsuranceValues: CreateLeasingProps = {
  leasingAmount: '',
  initialPayment: '',
  leasingPeriod: '',

  vehicles: [{ info: undefined, price: '', count: '' }],

  iin: '',
  companyName: '',
  bankDetails: '',
  oked: '',
  jobType: '',
  country: '',
  legalAddress: '',
  typeOfProperty: '',
  registrationPlace: '',
  registrationNumber: '',
  registrationDate: '',
  startWork: '',
  license: '',
  licenseDescription: '',
  licenseNumber: '',

  fullName: '',
  phone: '',
  email: '',

  managerName: '',
  managerDocument: '',
  managerDocumentNumber: '',
  managerDocumentIssueDate: '',
  managerDocumentEndDate: ''
};
